var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',[_c('v-tab',{attrs:{"to":{
          name: 'PatientRecordPAGoalSettingWeeklySportsGoal',
          params: {
              patientId: _vm.patientId
          }
      },"disabled":_vm.shouldBeDisabled}},[_vm._v(" "+_vm._s(_vm.$ucfirst(_vm.$t("pa.weeklySportsGoal")))+" ")]),_c('v-tab',{attrs:{"to":{
          name: 'PatientRecordPAGoalSettingDailyActivityGoal',
          params: {
              patientId: _vm.patientId
          }
      },"disabled":_vm.shouldBeDisabled}},[_vm._v(" "+_vm._s(_vm.$ucfirst(_vm.$t("pa.dailyActivityGoal")))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }